//# sourceMappingURL=ordered-list.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/list/ordered-list.interface.js
// module id = 1177
// module chunks = 4